import type { ReactNode } from 'react'
import { Box } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'

type TableScrollWrapperProps = {
  children: ReactNode
  sx?: SxProps<Theme>
  'data-testid'?: string
}

/** Keeps horizontal scroll on the table wrapper, not the page. */
export function TableScrollWrapper({ children, sx, 'data-testid': testId }: TableScrollWrapperProps) {
  return (
    <Box
      data-testid={testId ?? 'table-scroll-wrapper'}
      sx={[
        {
          width: '100%',
          maxWidth: '100%',
          overflowX: 'auto',
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </Box>
  )
}

export default TableScrollWrapper
